





































import Vue from "vue";
import moment from "moment";
import { Component } from "vue-property-decorator";
import { EventBus } from "../../../event-bus";
import { Getter } from "vuex-class";
import { IStore, IFetchRequest, IFetchResult } from "../api/store.interface";
import {
  StoreEventBus,
  ADD_EDIT_STORE,
  SHOW_FETCH_RESULTS,
  GET_STORES
} from "../api/store.event";

@Component({
  name: "storeToolbar"
})
export default class StoreToolbar extends Vue {
  // Getters
  @Getter("store/stores")
  stores: IStore[];
  @Getter("store/fetchResults")
  fetchResults: IFetchResult[];

  downloading: boolean = false;

  add() {
    let s: IStore = { id: -1, startDate: this.getToday() } as IStore;
    StoreEventBus.$emit(ADD_EDIT_STORE, s);
  }

  results() {
    StoreEventBus.$emit(SHOW_FETCH_RESULTS);
  }

  fetch(): void {
    var self = this;
    self.downloading = true;

    this.$store
      .dispatch("store/fetch", this.stores)
      .then(() => {
        self.downloading = false;
        EventBus.$emit("api-success", { message: "Download successful" });
        StoreEventBus.$emit(GET_STORES);
      })
      .catch(() => {
        EventBus.$emit("api-error", { message: "Download failed" });
        self.downloading = false;
      });
  }

  getToday(): string {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!
    var yyyy = today.getFullYear();

    var ddString = dd.toString();
    var mmString = mm.toString();
    var yyyyString = yyyy.toString();
    var todayString = "";

    if (dd < 10) {
      ddString = "0" + dd.toString();
    }

    if (mm < 10) {
      mmString = "0" + mm;
    }

    todayString = yyyyString + "-" + mmString + "-" + ddString;
    return todayString;
  }
}
